// ops.mbbe.dev (veya VITE_APP_TARGET=ops) ise personel operasyon portalı mount edilir.
// Staging deploys route ops-staging.mbbe.dev to this same application image.
const OPS_HOSTS = new Set(['ops.mbbe.dev', 'ops-staging.mbbe.dev', 'ops-passive.mbbe.dev', 'ops-staging-passive.mbbe.dev', 'ops.localhost']);

export function isOpsHost(): boolean {
  if (import.meta.env.VITE_APP_TARGET === 'ops') return true;
  if (typeof window === 'undefined') return false;
  return OPS_HOSTS.has(window.location.hostname.toLowerCase());
}
